import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
// esme login jo krega uska login k code likha h aur esme inline css use keya h 

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/login/user`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      if (response.ok) {
        const data = await response.json();
        console.log('Login successful:', data);

        // Assuming the backend returns a token or user data
        // You can store it in sessionStorage or localStorage if needed
        sessionStorage.setItem('isAuthenticated', true);
        navigate('/home'); // Redirect to home page after successful login
      } else {
        const errorData = await response.json();
        console.error('Login failed:', errorData);
        setError(errorData.message || 'Login failed');
      }
    } catch (error) {
      console.error('Error logging in:', error);
      setError('An error occurred while logging in. Please try again.');
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <h2>Login</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          style={styles.input}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={styles.input}
          required
        />
        <button type="submit" style={styles.button}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>
      {error && <p style={styles.error}>{error}</p>}
      
      {/* <p style={styles.createAccount}>
        Don't have an account? <Link to="/registrationuser" style={styles.link}>Create Account</Link>
      </p> */}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '400px',
    margin: '200px auto',
    padding: '20px',
    textAlign: 'center',
    border: '1px solid #ccc',
    borderRadius: '8px',
    backgroundColor: '#f9f9f9', // Light background color
  },
  input: {
    width: '100%',
    padding: '10px',
    margin: '10px 0',
    borderRadius: '4px',
    border: '1px solid #ccc',
  },
  button: {
    width: '100%',
    padding: '10px',
    backgroundColor: 'rgb(42 169 42)', // Green color with 50% opacity

    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  error: {
    color: 'red',
    marginTop: '10px',
  },
  createAccount: {
    marginTop: '20px',
    fontSize: '14px',
    color: '#333', // Darker text color
  },
  link: {
    color: 'rgb(42 169 42)',
    textDecoration: 'none',
    fontWeight: 'bold',
  },
};

export default Login;
